import { LegacyOttTrailerPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export const getPromoContentId = (trailer: LegacyOttTrailerPlayerBaseInfoContent) => {
    if (trailer.__typename === 'OttTrailer') {
        return trailer.contentGroupUuid;
    }

    return '';
};
